<div class="uk-child-width-1-1@s" uk-grid>
  <div>

    <div class="uk-background-cover uk-height-large uk-panel uk-flex uk-flex-center uk-flex-middle"
      style="background-image: url(../../assets/careerbanner.png); height:600px;">

      <div class="uk-position-center-left uk-position-large uk-text-left-top uk-light " style="margin-top:20px;">
        <h1 class="uk-heading-small uk-text-bold" style="margin-bottom: 0px;">Careers</h1>
        <p class="margin-top:0px;" uk-margin>
          <a class="uk-button uk-button-default  uk-button-small" href="#modal-sections1" uk-toggle>Web Development</a>
          <a class="uk-button uk-button-default  uk-button-small" href="#modal-sections2" uk-toggle>Mobile App
            Development</a>
          <a class="uk-button uk-button-default  uk-button-small" href="#modal-sections3" uk-toggle>Data Science</a>
          <a class="uk-button uk-button-default  uk-button-small" href="#modal-sections4" uk-toggle>Graphic
            Designing</a>

        </p>
        <p> <a class="uk-button uk-button-default  uk-button-small" href="#modal-sections5" uk-toggle>Digital
            Marketing</a>
          <a class="uk-button uk-button-default  uk-button-small" href="#modal-sections6" uk-toggle>Quality
            Assurance</a>

          <a class="uk-button uk-button-default  uk-button-small" href="#modal-sections7" uk-toggle>Business
            Development</a>
        </p>
        <div id="modal-sections1" uk-modal>
          <div class="uk-modal-dialog ">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header">
              <h3 class="uk-modal-title">Web Development</h3>
            </div>
            <div class="uk-modal-body">
              <p class="uk-text-medium uk-text-justify">You are responsible for designing, coding and
                modifying websites, from layout to function and according to a client's specifications.
                Write well designed, testable, efficient code by using best software development practices
                and create user interface by using standard HTML/CSS practices. You will be responsible
                for maintaining, expanding, and scaling both our site and client site. Stays plugged into
                emerging technologies/industry trends and apply them into operations and activities.</p>
            </div>
            <div class="uk-modal-footer uk-text-right">
              <button class="uk-button uk-button-primary uk-modal-close" type="button">Cancel</button>

            </div>
          </div>

        </div>




        <div id="modal-sections2" uk-modal>
          <div class="uk-modal-dialog ">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header">
              <h3 class="uk-modal-title">Mobile Development</h3>
            </div>
            <div class="uk-modal-body">
              <p class="uk-text-medium uk-text-justify">We always look for great talents who are passionate
                about their work. We need our developers to interact with the client and bring new ideas
                which shape a successful outcome. You can join us if you are a dedicated developer who can
                push the boundaries and bring innovations in your work. We create opportunities for your fast
                growth and let's join together in creating technologies that connect the world.</p>
            </div>
            <div class="uk-modal-footer uk-text-right">
              <button class="uk-button uk-button-primary uk-modal-close" type="button">Cancel</button>

            </div>
          </div>

        </div>





        <div id="modal-sections3" uk-modal>
          <div class="uk-modal-dialog ">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header">
              <h3 class="uk-modal-title">Data Science</h3>
            </div>
            <div class="uk-modal-body">
              <p class="uk-text-medium uk-text-justify">You should work closely with business
                stakeholders to understand their goals and determine how data can be used
                to achieve those goals. Design data modeling processes, create algorithms
                and predictive models to extract the data the business needs, and help
                analyze the data and share insights with peers. You should proactively
                fetch information from various sources and analyzes it for better
                understanding about how the business performs, and builds AI tools
                that automate certain processes within the company.</p>
            </div>
            <div class="uk-modal-footer uk-text-right">
              <button class="uk-button uk-button-primary uk-modal-close" type="button">Cancel</button>

            </div>
          </div>

        </div>


        <!-- <br>
                    <br> -->


        <div id="modal-sections4" uk-modal>
          <div class="uk-modal-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header">
              <h3 class="uk-modal-title">Graphic Designing</h3>
            </div>
            <div class="uk-modal-body">
              <p class="uk-text-medium uk-text-justify">You’ll be the one to shape the visual
                perspective of websites, books, magazines, product packaging, exhibitions
                and more.Your graphics should seek the attention of those who see them and
                convey the right message. For this, you need to have a creative flair and
                a strong ability to understand the requirements and translating them into
                design. If you can communicate well and work orderly as part of a team,
                we’d like to invite you.The major goal is to inspire and attract the
                target audience through fab works.</p>
            </div>
            <div class="uk-modal-footer uk-text-right">
              <button class="uk-button uk-button-primary uk-modal-close" type="button">Cancel</button>

            </div>
          </div>

        </div>



        <div id="modal-sections5" uk-modal>
          <div class="uk-modal-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header">
              <h3 class="uk-modal-title">Digital Marketing</h3>
            </div>
            <div class="uk-modal-body">
              <p class="uk-text-medium uk-text-justify">You will be responsible for looking
                into the online marketing strategies for the Organization. You can plan and
                execute marketing campaigns, and maintain & supply content for the
                Organization's website. You have to find the most popular and relevant
                keywords used in search engine queries and insert them into websites, to
                improve a website's ranking on search engines like Google. </p>
            </div>
            <div class="uk-modal-footer uk-text-right">
              <button class="uk-button uk-button-primary uk-modal-close" type="button">Cancel</button>

            </div>
          </div>

        </div>



        <div id="modal-sections6" uk-modal>
          <div class="uk-modal-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header">
              <h3 class="uk-modal-title">Quality Assurance</h3>
            </div>
            <div class="uk-modal-body">
              <p class="uk-text-medium uk-text-justify">We always look for great talents who
                are passionate about their work. We need our developers to interact with the
                client and bring new ideas which shape a successful outcome. You can join us
                if you are a dedicated developer who can push the boundaries and bring
                innovations in your work. We create opportunities for your fast growth
                and let's join together in creating technologies that connect the world.</p>
            </div>
            <div class="uk-modal-footer uk-text-right">
              <button class="uk-button uk-button-primary uk-modal-close" type="button">Cancel</button>

            </div>
          </div>

        </div>
        <!-- <br>
                    <br> -->


        <div id="modal-sections7" uk-modal>
          <div class="uk-modal-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header">
              <h3 class="uk-modal-title">Business Development</h3>
            </div>
            <div class="uk-modal-body">
              <p class="uk-text-medium uk-text-justify">The Business Development Executive
                is expected to work on new business proposals, plans and presentations which
                are a convincing representation of an Organisations products/services.The
                role of a Business Development Executive is to assist the Organisations
                sales and growth efforts by contributing to new customer investment. He/she
                should be able to provide ideas to attract new clients and keep the senior
                management and database updated accordingly.

              </p>
            </div>
            <div class="uk-modal-footer uk-text-right">
              <button class="uk-button uk-button-primary uk-modal-close" type="button">Cancel</button>



            </div>
          </div>


        </div>



      </div>
    </div>
  </div>
</div>

<!-- <br>
<br> -->
<div class="uk-section uk-section-default">
  <div class="uk-container">
    <div class="uk-column-1-2@s">



      <form [formGroup]="profileForm" class="uk-form-stacked">
        <!-- <div class="uk-child-width"> -->
        <!-- <div class="uk-width-1-2@s uk-child-width-1-2"> -->
        <div class="uk-child-width-expand">
          <label class="uk-form-title" for="form-stacked-text">Name :</label>
          <div class="uk-form-controls">
            <input formcontrolName="name" #name class="uk-input " id="form-stacked-text" type="text"
              placeholder="Enter Your Name*">
          </div>

        </div>
        <div class="uk-margin">
          <div class="uk-child-width-expand">
            <!-- <div class="uk-child-width-expand uk-child-width-small"> -->


            <label class="uk-form-title" for="form-stacked-text">Father Name :</label>
            <div class="uk-form-controls">

              <input formcontrolName="father_name" #father_name class="uk-input" id="form-stacked-text" type="text"
                placeholder="Enter Your Father Name*">
              <!-- </div>  -->
            </div>
          </div>
        </div>
        <div class="uk-child-width-expand">
          <label class="uk-form-title" for="form-horizontal-text">Place :</label>

          <input formcontrolName="place" #place class="uk-input" id="form-horizontal-text" type="text"
            placeholder="Enter Your Place*">

        </div>

        <div class="uk-margin">
          <div class="uk-child-width-expand">
            <label class="uk-form-title" for="form-horizontal-text">Date Of Birth :</label>


            <input formcontrolName="dob" #dob class="uk-input" id="form-horizontal-text" type="text"
              placeholder="mm/dd/yyyy*">


          </div>
        </div>
        <div class="uk-child-width-expand">
          <label class="uk-form-title" for="form-horizontal-select">Gender</label>

          <select formcontrolName="gender" #gender class="uk-select" id="form-horizontal-select">
            <option>Choose.....</option>
            <option>Male</option>
            <option>Female</option>
            <option>Other</option>
          </select>

        </div>



        <div class="uk-margin">
          <div class="uk-child-width-expand">
            <label class="uk-form-title" for="form-horizontal-text">Qualification :</label>

            <input formcontrolName="qualification" #qualification class="uk-input" id="form-horizontal-text" type="text"
              placeholder="Enter Your Qualification*">

          </div>
        </div>
        <div class="uk-child-width-expand">
          <label class="uk-form-title" for="form-horizontal-text">Year Of Passing :</label>

          <input formcontrolName="yop" #yop class="uk-input" id="form-horizontal-text" type="text"
            placeholder="Year Of Passing*">

        </div>
        <div class="uk-margin">
          <div class="uk-child-width-expand">
            <label class="uk-form-title" for="form-horizontal-text">Skills :</label>

            <input formcontrolName="skills" #skills class="uk-input" id="form-horizontal-text" type="text"
              placeholder="Enter Your Skills*">

          </div>

        </div>
        <div class="uk-child-width-expand">
          <label class="uk-form-title" for="form-horizontal-text">Email :</label>

          <input formcontrolName="email" #email class="uk-input" id="form-horizontal-text" type="text"
            placeholder="Enter Your Email*">

        </div>
        <div class="uk-margin">
          <div class="uk-child-width-expand">

            <label class="uk-form-title" for="form-horizontal-text">Phone :</label>

            <input formcontrolName="phone" #phone class="uk-input" id="form-horizontal-text" type="text"
              placeholder="Enter Your Phone Number*">

          </div>
        </div>




        &nbsp;<label class=" uk-text-center">Upload your Resume </label>
        <div class="uk-margin " uk-margin>
          <div uk-form-custom="target: true">
            <input type="file" (change)="onselectedfile($event)">

            <input class="uk-input uk-form-width-medium" type="text" placeholder="Select file" disabled>
          </div>


        </div>
        <!-- </div> -->


        <div>
          <a href="#mo2" uk-toggle><button
              (click)="onSubmit(name.value,father_name.value,place.value,dob.value,gender.value,qualification.value,yop.value,skills.value,email.value,phone.value)"
              class="uk-button uk-button-primary uk-button-large  ">Submit</button></a>
        </div>
      </form>
      <div id="mo2" uk-modal>
        <div class="uk-modal-dialog ">
          <button class="uk-modal-close-default" type="button" uk-close></button>

          <div class="uk-modal-body">
            <p class="uk-text-medium uk-text-justify">Your career details added successfully. Thankyou!</p>
          </div>
          <div class="uk-modal-footer uk-text-right">
            <button class="uk-button uk-button-primary uk-modal-close" type="button">Cancel</button>

          </div>
        </div>

      </div>
      <br>

      <h3>Ambition is the first step to success. <br>The second step is action </h3>
      <ul>
        <div class="uk-inline">
          <img data-src="assets/img/css.jpg" width="900" height="700" alt="" uk-img>

        </div>
      </ul>
      <ul>
        <article class="uk-article">
          <p class="uk-text-justify">The company gives more priority to quality work than quantity work. It helps for
            the overall growth of the employee along with the company. There is a lot of positive energy and unity in
            the team. </p>
          <p class="uk-article-meta uk-align-right" style="margin-bottom: 10px;">- Joji R</p><br>
          <!-- <p class="uk-text-justify">I am a CSE graduate, but I was not confident at coding. After stepping into
            WebSoulLabs,I had learnt many things, I got an opportunity to work with good team and there were a good work
            culture,Our higher officials made us pretty confident in coding field .</p>
          <p class="uk-article-meta uk-align-right" style="margin-bottom: 10px;">- Aparna TN </p><br> -->
          <p class="uk-text-justify">WebSoulLabs Give us a platform for Self Learning. WebSoulLabs helps me to achieve
            the goals of my life. My passion is Coding. After joining WebSoulLabs i got Job at Flutter Developer.</p>
          <p class="uk-article-meta uk-align-right" style="margin-bottom: 10px;">- Amina UC </p><br>
          <p class="uk-text-justify">I'm so happy for being a part of websoullabs family I started my career from here.I
            got to learn new technologies and i understand my self learning skill. The entire team of this family give
            me support and strength to grow up my career......thank you.
          </p>
          <p class="uk-article-meta uk-align-right" style="margin-bottom: 10px;">- Bency Philip </p><br>
        </article>

      </ul>
    </div>
  </div>
</div>
